<template>
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :closable="false"
    :draggable="false"
    :style="{ width: '400px' }"
    :breakpoints="{ '768px': '90vw' }"
  >
    <template #header>
      <span></span>
    </template>

    <div class="reading-content">
      <i class="pi pi-cloud-upload" style="font-size: 3rem; color: #185ea9"></i>
      <h4 class="reading-title">
        {{ t("wkt.client.expensesheets.reading-ticket-dialog.info") }}
      </h4>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const showDialog = ref(false);

function open() {
  showDialog.value = true;
}

function close() {
  showDialog.value = false;
}

defineExpose({
  open,
  close,
});
</script>

<style scoped>
.reading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 1rem;
}

.reading-title {
  margin: 0;
  text-align: center;
  color: #424242;
}
</style>
